export const DashboardText = 'Dashboard';
export const ConfirmText = 'Confirm';
export const SubmitText = 'Submit';
export const CancelText = 'Cancel';
export const SeemsToBeError = 'There seems to be an issue with the server.';
export const TryAgainLater = 'Please try again after sometime';
export const SaveText = 'Save';
